import type { StyleLayer } from './utils/types'

export const layers_bikelanes_details: StyleLayer[] = [
  {
    id: 'needsClarification-details',
    type: 'line',
    filter: ['match', ['get', 'category'], ['needsClarification'], true, false],
    paint: {
      'line-color': '#b50382',
      'line-dasharray': [2.5, 0.5],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 14, 2, 16, 3],
    },
  },
  {
    id: 'Gemeinsamer Fahrstreifen mit Kfz Markiert',
    type: 'line',
    filter: ['match', ['get', 'category'], ['sharedMotorVehicleLane'], true, false],
    paint: {
      'line-color': '#059669',
      'line-dasharray': [2, 1],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 14, 2, 16, 3],
    },
  },
  {
    id: 'Gemeinsamer Fahrstreifen mit Bus',
    type: 'line',
    filter: [
      'match',
      ['get', 'category'],
      ['sharedBusLaneBusWithBike', 'sharedBusLaneBikeWithBus'],
      true,
      false,
    ],
    paint: {
      'line-color': '#059669',
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 14, 2, 16, 3],
    },
  },
  {
    id: 'Fahrradstrasse Mischverkehr',
    type: 'line',
    filter: ['match', ['get', 'category'], ['bicycleRoad_vehicleDestination'], true, false],
    paint: {
      'line-color': '#fb923c',
      'line-dasharray': [2, 1],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 14, 2, 16, 3],
    },
  },
  {
    id: 'Fahrradstrasse keine Kfz',
    type: 'line',
    filter: ['match', ['get', 'category'], ['bicycleRoad'], true, false],
    paint: {
      'line-color': '#fb923c',
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 14, 2, 16, 3],
    },
  },
  {
    id: 'Gehweg Rad frei -details',
    type: 'line',
    filter: [
      'match',
      ['get', 'category'],
      [
        'pedestrianAreaBicycleYes',
        'footwayBicycleYes_isolated',
        'footwayBicycleYes_adjoiningOrIsolated',
        'footwayBicycleYes_adjoining',
      ],
      true,
      false,
    ],
    paint: {
      'line-color': '#f08ed5',
      'line-dasharray': [2, 2],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 14, 2, 16, 3],
    },
  },
  {
    id: 'Gemeinsamer Geh u Radweg',
    type: 'line',
    filter: [
      'match',
      ['get', 'category'],
      [
        'footAndCyclewayShared_adjoining',
        'footAndCyclewayShared_isolated',
        'footAndCyclewayShared_adjoiningOrIsolated',
      ],
      true,
      false,
    ],
    paint: {
      'line-color': '#e949ac',
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 14, 2, 16, 3],
    },
  },
  {
    id: 'Markierung Kreuzungsbereich',
    type: 'line',
    filter: ['match', ['get', 'category'], ['crossing'], true, false],
    paint: {
      'line-color': '#748b82',
      'line-dasharray': [2, 1],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 14, 2, 16, 3],
    },
  },
  {
    id: 'Schutzstreifen',
    type: 'line',
    filter: [
      'match',
      ['get', 'category'],
      [
        'cyclewayOnHighwayBetweenLanes',
        'cyclewayOnHighway_advisory',
        'cyclewayOnHighway_advisoryOrExclusive',
      ],
      true,
      false,
    ],
    paint: {
      'line-color': '#2dd4bf',
      'line-dasharray': [2, 1],
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 14, 2, 16, 3],
    },
  },
  {
    id: 'Radfahrstreifen',
    type: 'line',
    filter: ['match', ['get', 'category'], ['cyclewayOnHighway_exclusive'], true, false],
    paint: {
      'line-color': '#2dd4bf',
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 14, 2, 16, 3],
    },
  },
  {
    id: 'Geschuetzter Radfahrstreifen',
    type: 'line',
    filter: ['match', ['get', 'category'], 'cyclewayOnHighwayProtected', true, false],
    paint: {
      'line-color': '#7a0ff5',
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 14, 2, 16, 3],
    },
  },
  {
    id: 'Getrennter Radweg',
    type: 'line',
    filter: [
      'match',
      ['get', 'category'],
      ['cycleway_isolated', 'cycleway_adjoiningOrIsolated', 'cycleway_adjoining'],
      true,
      false,
    ],
    paint: {
      'line-color': '#174ed9',
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 14, 2, 16, 3],
    },
  },
  {
    id: 'Getrennter Rad- und Gehweg',
    type: 'line',
    filter: [
      'match',
      ['get', 'category'],
      [
        'footAndCyclewaySegregated_adjoiningOrIsolated',
        'footAndCyclewaySegregated_adjoining',
        'footAndCyclewaySegregated_isolated',
      ],
      true,
      false,
    ],
    paint: {
      'line-color': '#818cf8',
      'line-offset': ['interpolate', ['linear'], ['zoom'], 12, 0, 15, -1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 1.5, 14, 2, 16, 3],
    },
  },
  {
    id: 'hitarea-bikelanes-details',
    type: 'line',
    filter: ['has', 'category'],
    layout: {
      'line-cap': 'round',
    },
    paint: {
      'line-color': 'hsl(290, 100%, 54%)',
      'line-opacity': 0,
      'line-width': ['interpolate', ['linear'], ['zoom'], 9, 1, 14.1, 10, 22, 12],
    },
  },
]
